<div class="table-container">
  <!-- Loading State -->
  <div *ngIf="loading" class="loading-container">
    <app-data-loader [show]="true" [message]="loadingMessage" size="medium" />
  </div>

  <!-- Table Content -->
  <div *ngIf="!loading" class="table-wrapper">
    <!-- Fixed table rendering - removed ng-content, directly render rows -->
    <table *ngIf="data.length > 0" class="data-table" [style.min-width]="minTableWidth || null">
      <thead>
        <tr *ngIf="headerTemplate; else defaultHeaderRow">
          <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
        </tr>
        <ng-template #defaultHeaderRow>
          <tr>
            <th
              *ngFor="let column of columns; trackBy: trackByIndex"
              [class]="column.class"
              [class.th-sortable]="column.sortable"
              [style.width]="column.width"
              [attr.aria-sort]="isSortActive(column) ? (sortOrder === 'ASC' ? 'ascending' : 'descending') : null"
              (click)="column.sortable ? onHeaderSort(column) : null">
              <span class="th-sort-label">
                {{ column.label }}
                <mat-icon
                  *ngIf="column.sortable"
                  class="sort-icon"
                  [class.sort-icon--active]="isSortActive(column)"
                  aria-hidden="true">
                  {{
                    isSortActive(column)
                      ? (sortOrder === 'ASC' ? 'arrow_upward' : 'arrow_downward')
                      : 'unfold_more'
                  }}
                </mat-icon>
              </span>
            </th>
            <th *ngIf="actions.length > 0" class="th-actions">Actions</th>
          </tr>
        </ng-template>
      </thead>
      <tbody>
        <ng-container *ngIf="rowTemplate; else defaultRows">
          <ng-container *ngFor="let row of data; let i = index">
            <ng-container *ngTemplateOutlet="rowTemplate; context: { $implicit: row, index: i }"></ng-container>
          </ng-container>
        </ng-container>

        <!-- ✅ Default auto-rendering if no custom template -->
        <ng-template #defaultRows>
          <tr *ngFor="let row of data; trackBy: trackByIndex" (click)="onRowClick(row)">
            <td *ngFor="let column of columns; trackBy: trackByIndex">
              {{ getCellValue(row, column) }}
            </td>
            <td *ngIf="actions.length > 0" class="td-actions">
              <!--
                shouldShowAction() applies each action's own `show` predicate, which is
                evaluated PER ROW. Station permissions are per-station, so on a list of
                stations the same user may edit one row and only view the next. Without
                this guard every action rendered on every row.
              -->
              <ng-container *ngFor="let action of actions">
                <button *ngIf="shouldShowAction(action, row)" class="action-btn" [ngClass]="action.class"
                  (click)="action.callback(row); $event.stopPropagation()" [title]="action.label">
                  <mat-icon>{{ action.icon }}</mat-icon>
                </button>
              </ng-container>
            </td>
          </tr>
        </ng-template>
      </tbody>
    </table>

    <!-- Empty State -->
    <div *ngIf="data.length === 0" class="empty-state">
      <mat-icon *ngIf="emptyIcon" class="empty-icon empty-icon-mat" aria-hidden="true">{{ emptyIcon }}</mat-icon>
      <svg *ngIf="!emptyIcon" class="empty-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4">
        </path>
      </svg>
      <h3 class="empty-title">{{ emptyMessage }}</h3>
      <p *ngIf="emptyDescription" class="empty-description">{{ emptyDescription }}</p>
      <button *ngIf="showAddButton" type="button" class="btn-primary" (click)="onAddClick()">
        <mat-icon aria-hidden="true">add</mat-icon>
        <span>{{ addButtonText }}</span>
      </button>
    </div>
  </div>
</div>